import { render, staticRenderFns } from "./DocumentService.vue?vue&type=template&id=916af630&scoped=true"
import script from "./DocumentService.vue?vue&type=script&lang=js"
export * from "./DocumentService.vue?vue&type=script&lang=js"
import style0 from "./DocumentService.vue?vue&type=style&index=0&id=916af630&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "916af630",
  null
  
)

export default component.exports